import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_GROUP_CONVERSATION_LIKES,
    FETCH_GROUP_CONVERSATION_LIKES_FETCHING,
    FETCH_GROUP_CONVERSATION_LIKES_FINISHED
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

export function* fetchGroupConversationLikes(action) {
    const { userGroupPk, resourceId, resourceType, start, limit, connectionStatusIncluded } = action.payload;

    try {
        yield put({
            type: FETCH_GROUP_CONVERSATION_LIKES_FETCHING
        });

        let url = `conversation-service/conversation/likes/${userGroupPk}/${resourceType}/${resourceId}`;
        if (
            typeof start != 'undefined' &&
            typeof limit != 'undefined' &&
            typeof connectionStatusIncluded != 'undefined'
        ) {
            url += `?start=${start}&limit=${limit}&connectionStatusIncluded=${connectionStatusIncluded}`;
        }

        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_GROUP_CONVERSATION_LIKES_FINISHED,
            data: response.data,
            receivedAt: Date.now(),
            resourceId
        });
    } catch (e) {
        console.log(e);
    }
}

export const groupConversationLikesSagas = [takeEvery(FETCH_GROUP_CONVERSATION_LIKES, fetchGroupConversationLikes)];
